import React from 'react'

function Role() {
  return (
  <section className="bg-gray-100">
    <div className="max-w-screen-xl	mx-auto text-center">
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-between py-10 px-0">
        <div className="lg:w-1/5 md:w-4/12 sm:w-full flex flex-row justify-start items-start">
          <div className="pr-5">
            <img src={require('../../common/images/role.svg')} alt="Role Art"/>
          </div>
          <div className="text-left">
            <p className="font-bold">ROLE</p>
            <p className="text-sm text-gray-500">Product Manager</p>
            <p className="text-sm text-gray-500">UX/UI Designer</p>
          </div>
        </div>
        <div className="lg:w-1/5 md:w-4/12 sm:w-full flex flex-row justify-start items-start">
          <div className="pr-5">
            <img src={require('../../common/images/duration.svg')} alt="Duration Art"/>
          </div>
          <div className="text-left">
            <p className="font-bold">DURATION</p>
            <p className="text-sm text-gray-500">Sept 2016 - Dec 2020</p>
          </div>
        </div>
        <div className="lg:w-1/5 md:w-4/12 sm:w-full flex flex-row justify-start items-start">
          <div className="pr-5">
            <img src={require('../../common/images/team.svg')} alt="Team Art"/>
          </div>
          <div className="text-left">
            <p className="font-bold">TEAM</p>
            <p className="text-sm text-gray-500">3 Designers</p>
            <p className="text-sm text-gray-500">5-7 Engineers & QA</p>
            <p className="text-sm text-gray-500">3 Support</p>
          </div>
        </div>
        <div className="lg:w-1/5 md:w-4/12 sm:w-full flex flex-row justify-start items-start">
          <div className="pr-5">
            <img src={require('../../common/images/product.svg')} alt="Product Art"/>
          </div>
          <div className="text-left">
            <p className="font-bold">PRODUCT</p>
            <p className="text-sm text-gray-500">SeeYouDoc</p>
          </div>
        </div>
        <div className="lg:w-1/5 md:w-4/12 sm:w-full flex flex-row justify-start items-start">
          <div className="pr-5">
            <img src={require('../../common/images/agency.svg')} alt="Agency Art"/>
          </div>
          <div className="text-left">
            <p className="font-bold">AGENCY</p>
            <p className="text-sm text-gray-500">SeeYouDoc Corp.</p>
            <p className="text-sm text-gray-500">Full-time</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Role
